require('./tab');

(function(){
  var timer;

  Pegasus.ToolbarView = Em.View.extend({
    classNames: ['toolbar-top'],
    templateName: 'toolbar/empty',

    actionBinding: 'containerView.currentView.action',

    selectView: function(mode){
      this.set('controller.content.payload.type', mode );
    },

    tabsView: Em.ContainerView.extend({
      tagName: 'ul',
      classNames: ['tabs'],
      childViews:  function() {
        var tabs = ['blocks', 'edit', 'palette', 'ai'];

        return tabs;
      }.property(),

      selectView: function(mode){
        this.get('parentView').selectView( mode );
      },
      activeModeBinding: 'parentView.containerView.mode',
      blocks: Pegasus.TabView.extend({
        classNames: ['blocks-tab'],
        template: Em.Handlebars.compile('<span class="tab-description">{{t g.add}}<br/>{{t g.content}}</span>'),
        mode: 'Blocks',
        click: function(){
          var callback = function(){
            Em.run.scheduleOnce('afterRender', this, 'set', 'controller.content.payload.type', this.get('mode'));
          }.bind(this);

          if ( this.get('isActive') ) { return; }

          this.set('controller.panelMode', 'Blocks');

          Pegasus.lookupController('frameCommManager').send('requestRowAddition');

          callback();
        }
      }),
      edit: Pegasus.TabView.extend({
        classNames: ['edit-tab'],
        template: Em.Handlebars.compile('<span class="tab-description">{{t g.edit}}<br/>{{t g.content}}</span>'),
        mode: 'Edit',
        click: function(){
          var callback = function(){
            Em.run.scheduleOnce('afterRender', this, 'set', 'controller.content.payload.type', this.get('mode'));
          }.bind(this);

          if ( this.get('isActive') ) { return; }

          this.set('controller.panelMode', 'Edit');

          Pegasus.lookupController('frameCommManager').send('enteredIdleState');

          callback();
        }
      }),

      ai: Pegasus.TabView.extend({
        classNames: ['ai-tab'],
        template: Em.Handlebars.compile('<span class="tab-description">{{t g.ai}}<br/>{{t g.assistant}}<br/>{{t g.beta}}</span>'),
        mode: 'ai',
        click: function(){
          var callback = function(){
            Em.run.scheduleOnce('afterRender', this, 'set', 'controller.content.payload.type', this.get('mode'));
          }.bind(this);

          if ( this.get('isActive') ) { return; }

          this.set('controller.panelMode', 'ai');

          callback();
        }
      }),


      palette: Pegasus.TabView.extend({
        classNames: ['palette-tab'],
        template: function(){
          var loadedType = Pegasus.loadedTemplate().get('underscore_type');
          return Em.Handlebars.compile('<span class="tab-description">{{t '+ loadedType +'.palette.style}}</span>');
        }.property(),
        mode: function(){
          return Pegasus.loadedTemplate().get('paletteType');
        }.property(),
        click: function(){
          var mode = Pegasus.loadedTemplate().get('paletteType') || 'Palette';

          if ( this.get('isActive') ) { return; }

          this.set('controller.panelMode', mode);

          var callback = function(){
            Em.run.scheduleOnce('afterRender', this, function(){
              this.set('controller.content.payload.type', mode);
            });
          }.bind(this);

          Pegasus.lookupController('frameCommManager').send('requestEditPalette');

          callback();
        },
      }),

      help: Pegasus.TabView.extend({
        classNames: ['help-tab'],
        template: Em.Handlebars.compile('<span>{{t g.help}}</span>'),
        mode: 'Help'
      })
    }),

    toolbarDescription: Em.View.extend({
      classNames: ['vr-toolbar'],
      templateName: 'toolbar_description'
    }),

    subTabView: Em.ContainerView.extend({
      viewName: 'tabs',
      tagName: 'ul',
      classNames: ['tabs', 'sub-tabs'],
      childViews: ['subTabOne', 'subTabTwo'],
      selectView: function(mode){
        this.get('parentView').selectSubTabMode( mode );
      },
      activeModeBinding: 'controller.subTabMode',
      subTabOne: Pegasus.TabView.extend({
        template: Em.Handlebars.compile('{{controller.subTabOneDisplay}}'),
        modeBinding: 'controller.subTabOneMode'
      }),
      subTabTwo: Pegasus.TabView.extend({
        template: Em.Handlebars.compile('{{controller.subTabTwoDisplay}}'),
        modeBinding: 'controller.subTabTwoMode'
      })
    }),

    selectSubTabMode: function(mode){
      this.set('controller.subTabMode', mode);
    },

    contentView: Em.ContainerView.extend({
      classNames: ['root-toolbar-content-wrapper'],
      classNameBindings: ['activeModeClass'],
      viewName: 'containerView',

      activeModeClass: function(){
        return this.get('mode').dasherize();
      }.property('mode'),

      mode: function(_,value) {
        if ( typeof(value) !== 'undefined' ) {
          this.set('controller.panelMode', value);
          return value;
        }

        return this.get('controller.panelMode');
      }.property('controller.panelMode'),

      currentView: null,

      didChangePayload: function(){
        var payloadType;
        var self = this;

        if ( !this.$() ) { return; }

        payloadType = this.get('controller.content.payload.type');

        if ( payloadType ) {
          this.set('currentView', null);
          import( "../../lazy_components/toolbars/"+payloadType.underscore()+"/toolbar.js" ).then(function(view){
            Em.run.scheduleOnce( 'afterRender', self, 'set', 'currentView', view.default.create({
              container: self.container
            }) );
          });
          return;
        }

        this.set('currentView', null);
      }.observes('controller.content.payload.type'),

      mouseEnter: function(){
        this.get('controller').send('hideControls');
      },

      click: function(){
        if ( this.get('controller.content') ){
          this.set('controller.touched', true);
        }
      },

      //ViewOnline: Pegasus.ViewOnlineToolbarView,

      //Footer: Pegasus.FooterToolbarView,

      //WebTemplateFooter: Pegasus.WebTemplateFooterToolbarView,

      //CaptureTemplateFooter: Pegasus.CaptureTemplateFooterToolbarView,

      //Palette: Pegasus.PaletteToolbarView.extend({
        //action: 'Editing Theme'
      //}),

      //WebTemplatePalette: Pegasus.WebTemplatePaletteToolbarView.extend({
        //action: 'Editing Theme'
      //}),

      //CapturePalette: Pegasus.CapturePaletteToolbarView.extend({
        //action: 'Editing Theme'
      //}),

      //BodyImage: Pegasus.BodyImageToolbarView.extend({
        //action: 'Editing Email Background Image'
      //}),

      //WebTemplateBodyImage: Pegasus.WebTemplateBodyImageToolbarView.extend({
        //action: 'Editing Background Image'
      //}),

      //CaptureTemplateBodyImage: Pegasus.CaptureTemplateBodyImageToolbarView.extend({
        //action: 'Editing Background Image'
      //}),

      //EmailTemplateBackgroundImage: Pegasus.BackgroundImageToolbarView.extend({
        //action: 'Editing Background Image'
      //}),

      //WebTemplateBackgroundImage: Pegasus.WebTemplateBackgroundImageToolbarView.extend({
        //action: 'Editing Background Image'
      //}),

      //CaptureTemplateBackgroundImage: Pegasus.CaptureTemplateBackgroundImageToolbarView.extend({
        //action: 'Editing Backdrop Image'
      //}),

      //CaptureTemplateBlockRegionImage: Pegasus.CaptureTemplateBlockRegionImageToolbarView.extend({
        //action: 'Editing Background Image'
      //}),

      //Image: Pegasus.ImageToolbarView.extend({
        //action: 'Editing Image'
      //}),

      //WebTemplateImage: Pegasus.WebTemplateImageToolbarView.extend({
        //action: 'Editing Image'
      //}),

      //WebTemplateForm: Pegasus.WebTemplateFormToolbarView.extend({
        //action: 'Editing Form'
      //}),

      //WebTemplateText: Pegasus.WebTemplateTextToolbarView.extend({
        //action: 'Editing Text'
      //}),

      //CaptureTemplateImage: Pegasus.CaptureTemplateImageToolbarView.extend({
        //action: 'Editing Image'
      //}),

      //CaptureTemplateForm: Pegasus.CaptureTemplateFormToolbarView.extend({
        //action: 'Editing Form'
      //}),

      //CaptureTemplateText: Pegasus.CaptureTemplateTextToolbarView.extend({
        //action: 'Editing Text'
      //}),


      //SocialShare: Pegasus.SocialShareToolbarView.extend({
        //action: 'Editing Social Share'
      //}),

      //SocialFollow: Pegasus.SocialFollowToolbarView.extend({
        //action: 'Editing Social Follow'
      //}),

      //Text: Pegasus.TextToolbarView.extend({
        //action: 'Editing Text'
      //}),
      //Button: Pegasus.ButtonToolbarView,
      //PreferencesButton: Pegasus.PreferencesButtonToolbarView,
      //WebTemplateButton: Pegasus.WebTemplateButtonToolbarView,
      //WebTemplateWidget: Pegasus.WebTemplateWidgetToolbarView,
      //CaptureTemplateButton: Pegasus.CaptureTemplateButtonToolbarView,
      //CaptureTemplateWidget: Pegasus.CaptureTemplateWidgetToolbarView,
      //Divider: Pegasus.DividerToolbarView
    })
  });
})();
